import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setItemArchiveItem = (state, statusId, archiveItem) => {
    const item = state.items.find((s) => s.id === statusId);
    item.is_archive = archiveItem;
};

const state = () => ({
    items: [],
});

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    putNewItem(state, item) {
        state.items.unshift(item);
    },
    updateItem(state, statusData) {
        const item = state.items.find((s) => s.id === statusData.id);
        Object.keys(item).forEach((key) => {
            item[key] = statusData[key];
        });
    },
    deleteItem(state, statusId) {
        state.items = state.items.filter((s) => s.id !== statusId);
    },
    moveItemToArchive(state, statusId) {
        setItemArchiveItem(state, statusId, ARCHIVED);
    },
    moveItemFromArchive(state, statusId) {
        setItemArchiveItem(state, statusId, NOT_ARCHIVED);
    },
};

const actions = {
    async fetchItems({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/index&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setItems", data);
    },
    async createItem({ rootState, commit }, statusData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/create`, token);

        const { data } = await axios.post(url, statusData);

        if (data.success) {
            commit("putNewItem", data.model);
        }

        return data;
    },
    async updateItem({ rootState, commit }, statusData) {
        const token = rootState.authToken;
        const statusId = statusData.id;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/update&id=${statusId}`, token);

        const { data } = await axios.put(url, statusData);

        if (data.success) {
            commit("updateItem", data.model);
        }

        return data;
    },
    async deleteItem({ rootState, commit }, statusId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/delete&id=${statusId}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteItem", statusId);
        }
    },
    async moveItemToArchive({ rootState, commit }, statusId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/archive&id=${statusId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveItemToArchive", statusId);
        }
        return data.success;
    },
    async moveItemFromArchive({ rootState, commit }, statusId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/archive&id=${statusId}&is_archive=0`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveItemFromArchive", statusId);
        }

        return data.success;
    },
    async updateSort({ rootState, state }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/vacancy-status/update-sort`, token);

        const sortingData = state.items.map((s, sIndex) => ({ id: s.id, sort: state.items.length - sIndex }));

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
